import { FC } from 'react';

import { LabelStyled } from './Label.styles';
import { LabelProps } from './Label.types';

const Label: FC<LabelProps> = (props: LabelProps) => {
  const { children, ...rest } = props;
  return <LabelStyled {...rest}>{children}</LabelStyled>;
};

export default Label;
